<template>
  <div>
    <FormInput label="Chat ID" :value="data.chat_id" hint="@channelusername or @groupusername" @update="data.chat_id=$event"></FormInput>
    <h5>Tasks to execute if user is not member of channel/group.</h5>
    <Task :tasks="data.else_tasks" :actions="actions"></Task>
  </div>
</template>


<script>
import FormInput from '@/components/tasks/fields/FormInput.vue'

export default {
  name: 'IsChatMember',
  components:{
    FormInput,
    Task: () => import("@/components/Task.vue")
  },
  props: {
    data: Object,
    actions: Object
  },
}
</script>
